import { GridOptions } from 'ag-grid-community'
import { isProductsDetailsColumnHeaderRightClickMenuVar } from 'cache/products-details'
import { createAgGridFrameworkComponents } from 'components/AgGrid'

/**
 * Framework components for AG Grid
 * Registers custom components (header, tooltip, etc.)
 */
export const frameworkComponents: Record<string, any> = createAgGridFrameworkComponents(
  isProductsDetailsColumnHeaderRightClickMenuVar
)

/**
 * Grid options for ProductsDetailsGrid
 */
export const productsDetailsGridOptions: Partial<GridOptions> = {
  suppressRowClickSelection: false,
  suppressCellFocus: false,
  stopEditingWhenCellsLoseFocus: true,
  rowSelection: 'single',
  animateRows: true,
  enableRangeSelection: false,
  suppressMenuHide: true,
  tooltipShowDelay: 500,
  enableCellTextSelection: false,
  ensureDomOrder: true,
  rowHeight: 32,
  headerHeight: 36,
  suppressContextMenu: true,
  preventDefaultOnContextMenu: false,
  getRowId: (params) => params.data.id?.toString() || '',
}
